<template>
  <div class="footer-div mt-3 pb-3">
    <footer class="pl-3 pr-3 row">
      <div class="col-lg-4 col-md-6 col-sm-12" style="padding-left: 15px">
        <div class="title nav-link">ติดต่อเรา</div>
        <div class="address">
          <div style="font-size: 24px; font-weight: bold">กองป้องกันการบาดเจ็บ</div>
          <div style="font-size: 24px; font-weight: bold;padding-bottom: 5px">กรมควบคุมโรค กระทรวงสาธารณสุข</div>
          <div><i class="fa fa-phone-square" aria-hidden="true"></i><span style="padding-left: 1.2em">0 2590 3953</span></div>
          <div><i class="fa fa-envelope" aria-hidden="true"></i><span style="padding-left: 1.1em">otherinjury@gmail.com</span></div>
          <div><i class="fa fa-globe" aria-hidden="true"></i><a href="https://ddc.moph.go.th/dip">https://ddc.moph.go.th/dip</a></div>
          <div><i class="fab fa-facebook-f"></i><a href="https://www.facebook.com/thaiinjury"> www.facebook.com/thaiinjury</a></div>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div class="title nav-link"><a href="https://ddc.moph.go.th/dip/#m1326">ข้อมูลข่าวสาร</a></div>
        <div class="content">
          <div class="nav-link"><a href="https://ddc.moph.go.th/dip/newspic.php">ข่าวประชาสัมพันธ์</a></div>
          <div class="nav-link"><a href="https://ddc.moph.go.th/dip/newsactivity.php">ข่าวกิจกรรม</a></div>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div class="title nav-link"><a href="https://ddc.moph.go.th/dip/#m1325">คลังสื่อ</a></div>
        <div class="content">
          <div class="nav-link"><a href="https://ddc.moph.go.th/dip/publishinfo.php?info">Infographic</a></div>
          <div class="nav-link"><a href="https://ddc.moph.go.th/dip/mediavdo.php">สื่อมัลติมีเดีย</a></div>
        </div>
      </div>
      <div class="col-3">
        <iframe
          src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fthaiinjury%2F&tabs=timeline&width=250&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId"
          width="340" height="200" style="border:none;overflow:hidden" scrolling="no" frameborder="0"
          allowTransparency="true" allow="encrypted-media"></iframe>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "FooterView"
  }
</script>

<style scoped>
  .footer-div {
    padding: 25px 15px;
    color: #359091;
    font-size: 22px;
    line-height: 1.2;
    vertical-align: bottom;
    width: 100%;
    background: #E7E7E7 !important;
  }

  .title , .title a {
    color: #359091 !important;
    font-size: 24px;
    font-weight: bolder;
    line-height: 1.5;
  }

  .content , .content a {
    color: #359091 !important;
    line-height: 0.6;
    padding-left: 5px;
    font-weight: normal;
  }
  .address , .address a {
    color: #359091 !important;
    line-height: 1.2;
    padding-left: 25px;
    font-weight: normal;
  }
</style>
